import { api, PartipostApiPaginationWrapper, PartipostApiResponse } from './'
import { EngagementId } from 'state/tasks'
import { OptionTypes, TagCategoryEnum } from 'state/constants'

export type ConstantsRequest = any

export interface PollCategories {
    uuid: string
    label: string
}

export interface PollSectionTypes {
    id: string
    label: string
}

export interface RejectionReasonTypes {
    id: string
    name: string
}

export interface CampaignSubmissionStatuses {
    id: string
    label: string
}

export enum TASK_TYPE_ENUM {
    IG_POST = 'instagram_post',
    IG_POST_V02 = 'instagram_post_v02',
    IG_STORY = 'instagram_story',
    IG_STORY_V02 = 'instagram_story_v02',
    FB_POST = 'facebook_post',
    FB_POST_V02 = 'facebook_post_v02',
    PURCHASE_PRODUCT = 'purchase_product',
    ATTEND_EVENT = 'attend_event',
    CUSTOM = 'custom',
    TIKTOK_POST = 'tiktok_post',
    IG_REEL = 'instagram_reel',
    XIAOHONGSHU_POST = 'xiaohongshu_post',
}

// all v2+ task will have engagement step in the future, so we can use task version to determin does engagement step exist
export const TasksWithEngagementStep = [
    TASK_TYPE_ENUM.IG_STORY_V02,
    TASK_TYPE_ENUM.IG_POST_V02,
    TASK_TYPE_ENUM.TIKTOK_POST,
    TASK_TYPE_ENUM.FB_POST_V02,
    TASK_TYPE_ENUM.IG_REEL,
    TASK_TYPE_ENUM.XIAOHONGSHU_POST,
]

export interface PayoutType {
    id: string
    no_counter?: boolean
    label: string
    is_engagement?: boolean
}

export interface TaskTypes {
    config: {
        payout_types: PayoutType[]
        platform: number | null
        tracking_duration: number
        steps: string[]
        verification_required_default: boolean
        engagement_types?: string[]
        idle_hours_to_submit_engagement?: number
    }
    name: TASK_TYPE_ENUM
    label: string
}

export interface CampaignObjectives {
    id: number
    label: string
}

export interface CampaignRequirementTypes {
    id: number
    label: string
}

export interface SubmissionStatuses {
    id: number
    label: string
}

export interface CampaignCategories {
    id: number
    label: string
}

export interface CampaignOptions {
    id: string
    label: string
}

export enum STEP_TYPE_ENUM {
    SUBMIT_CONTENT_IG_POST = 'submit_content_instagram_post',
    SUBMIT_CONTENT_FB_POST = 'submit_content_facebook_post',
    SUBMIT_CONTENT_IG_STORY = 'submit_content_instagram_story',
    SUBMIT_CONTENT_TIKTOK_POST = 'submit_content_tiktok_post',
    SUBMIT_CONTENT_XIAOHONGSHU_POST = 'submit_content_xiaohongshu_post',
    SUBMIT_CONTENT_IG_REEL = 'submit_content_instagram_reel',
    POST_TO_IG_POST = 'post_to_instagram_post',
    POST_TO_FB_POST = 'post_to_facebook_post',
    POST_TO_IG_STORY = 'post_to_instagram_story',
    SUBMIT_PROOF_URL = 'submit_proof_url',
    SUBMIT_PROOF_IG_URL = 'submit_proof_instagram_url',
    SUBMIT_PROOF_IG_SCREENSHOT = 'submit_proof_instagram_story_screenshot',
    POST_AND_SUBMIT_PROOF_INSTAGRAM_POST_URL = 'post_and_submit_proof_instagram_post_url',
    POST_AND_SUBMIT_PROOF_TIKTOK_POST_URL = 'post_and_submit_proof_tiktok_post_url',
    POST_AND_SUBMIT_PROOF_XIAOHONGSHU_POST_URL = 'post_and_submit_proof_xiaohongshu_post_url',
    POST_AND_SUBMIT_PROOF_FACEBOOK_POST_URL = 'post_and_submit_proof_facebook_post_url',
    POST_AND_SUBMIT_PROOF_INSTAGRAM_REEL_URL = 'post_and_submit_proof_instagram_reel_url',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_FACEBOOK_POST = 'submit_engagement_results_and_proof_facebook_post',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_IG_SCREENSHOT = 'submit_engagement_results_and_proof_instagram_story',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_IG_POST = 'submit_engagement_results_and_proof_instagram_post',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_TIKTOK_POST = 'submit_engagement_results_and_proof_tiktok_post',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_XIAOHONGSHU_POST = 'submit_engagement_results_and_proof_xiaohongshu_post',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_INSTAGRAM_REEL = 'submit_engagement_results_and_proof_instagram_reel',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_TWITTER_POST = 'submit_engagement_results_and_proof_twitter_post',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_YOUTUBE_VIDEO = 'submit_engagement_results_and_proof_youtube_video',
    SUBMIT_ENGAGEMENT_RESULTS_AND_PROOF_OTHERS = 'submit_engagement_results_and_proof_others',
    SUBMIT_PROOF_FB_URL = 'submit_proof_facebook_url',
    SUBMIT_PROOF_PHOTO = 'submit_proof_photo',
    PURCHASE_PRODUCT = 'purchase_product',
    ATTEND_EVENT = 'attend_event',
    CUSTOM = 'custom',
}

export interface StepTypes {
    config: {
        step: {
            fields: {
                [field_name: string]: object
            }
        }
        submission: {
            fields: {
                [field_name: string]: object
            }
        }
        is_approval_required: boolean
        is_engagement_submission_step: boolean
        is_url_or_screenshot_submission_step: boolean
    }
    name: STEP_TYPE_ENUM
    label: string
}

export interface CampaignStatuses {
    id: number
    label: string
}

export interface PollStatuses {
    id: number
    label: string
}

export interface TeamTypes {
    id: string
    label: string
}

export interface TagCategories {
    uuid: string
    enum: string
    target: string
    allow_multiple: boolean
}

export type TagSeverity = 'bad' | 'average' | 'good'

export interface Tag {
    uuid: string
    category: {
        allow_multiple: boolean
        enum: string
        target: string
        uuid: string
    }
    is_custom: boolean
    name: string
    severity: TagSeverity
}

export interface CityType {
    rank: number
    id_name: string
    name: string
}

export enum COUNTRY_ENUM {
    SG = 'SG',
    TW = 'TW',
    ID = 'ID',
    PH = 'PH',
    MY = 'MY',
    HK = 'HK',
    TH = 'TH',
    VN = 'VN',
}

export type Country = keyof typeof COUNTRY_ENUM

export interface BankDetail {
    account_name: string
    account_number: string
    bank_address: string
    bank_code: string
    bank_name: string
    branch_code: string
    swift_code: string
}

export interface CountrySettings {
    currency: {
        code: string
        name: string
        sign: string
        round_up?: boolean
    }
    city_types: CityType[]
    partipost_bank_details: BankDetail
    stripe_payment_supported: boolean
    minimum_budget_for_template: number
    default_campaign_image_url: string
    prefix: string
}

export enum PLATFORM_CONTENT_TYPE_ENUM {
    INSTAGRAM_STORY = 'instagram_story_content_type',
    INSTAGRAM_POST = 'instagram_post_content_type',
    INSTAGRAM_REEL = 'instagram_reel_content_type',
    FACEBOOK_POST = 'facebook_post_content_type',
    TIKTOK_POST = 'tiktok_post_content_type',
    XIAOHONGSHU_POST = 'xiaohongshu_post_content_type',
    TWITTER_POST = 'twitter_post_content_type',
    YOUTUBE_VIDEO = 'youtube_video_content_type',
    DOWNLOAD_APP = 'download_app_content_type',
    WRITE_REVIEW = 'write_review_content_type',
    FOLLOW_ACCOUNT = 'follow_account_content_type',
    PURCHASE_PRODUCT = 'purchase_product_content_type',
    ATTEND_EVENT = 'attend_event_content_type',
    REFERRAL = 'referral_content_type',
    USER_TUTORIAL = 'user_tutorial_content_type',
    PAYOUTS = 'payouts_content_type',
    VIDEO_CREATION = 'video_creation_content_type',
    PHOTO_CREATION = 'photo_creation_content_type',
    OTHERS = 'others_content_type',
}

//todo: extend this if other task need to support UGC/Non UGC
export const PLATFORM_CONTENT_TYPE_FILTER = {
    ...PLATFORM_CONTENT_TYPE_ENUM,
    INSTAGRAM_STORY_UGC: 'instagram_story_content_type:ugc',
    INSTAGRAM_STORY_NON_UGC: 'instagram_story_content_type:non_ugc',
    WRITE_REVIEW_IMAGE_APPROVAL: 'write_review_content_type:image:approval',
    WRITE_REVIEW_NON_IMAGE_APPROVAL: 'write_review_content_type:non_image:approval',
    WRITE_REVIEW_IMAGE_NON_APPROVAL: 'write_review_content_type:image:non_approval',
    WRITE_REVIEW_NON_IMAGE_NON_APPROVAL: 'write_review_content_type:non_image:non_approval',
} as const

type PlatformContentTypeFilterType = keyof typeof PLATFORM_CONTENT_TYPE_FILTER
export type PlatformContentTypeFilter = (typeof PLATFORM_CONTENT_TYPE_FILTER)[PlatformContentTypeFilterType]

export type EngagementType = {
    id: EngagementId
    label: string
    deprecated: boolean
}

export type PlatformContentType = {
    name: PLATFORM_CONTENT_TYPE_ENUM
    label: string
    engagement_types: EngagementType[]
    engagement_step_type: STEP_TYPE_ENUM | null
    idle_hours_to_submit_engagement: number | null
}

export type ConstantsResponse = {
    poll_categories?: PollCategories[]
    poll_section_types?: PollSectionTypes[]
    rejection_reason_types?: RejectionReasonTypes[]
    country_settings: {
        [key in COUNTRY_ENUM]: CountrySettings
    }
    campaign?: {
        campaign_submission_status: CampaignSubmissionStatuses[]
        task_types: TaskTypes[]
        campaign_objections: CampaignObjectives[]
        campaign_requirement_types: CampaignRequirementTypes[]
        submission_status: SubmissionStatuses[]
        campaign_categories: CampaignCategories[]
        step_types: StepTypes[]
        campaign_status: CampaignStatuses[]
        platform_content_types: PlatformContentType[]
        submission_earnings_adjustment_reasons: CampaignOptions[]
        submission_earnings_adjustment_source: CampaignOptions[]
        submission_paid_outside_app_reasons: CampaignOptions[]
        submission_paid_outside_app_payment_methods: CampaignOptions[]
    }
    poll_status?: PollStatuses[]
    tag_categories?: TagCategories[]
    tags?: Tag[]
    profiles?: {
        business_types?: OptionTypes[]
    }
    teams?: {
        types: TeamTypes[]
        default_service_fee_percentage: number
    }
}

export const getConstants = () => api.get<PartipostApiResponse<ConstantsResponse>>('common/data/')

export interface LocationOptionsRequest {
    country: COUNTRY_ENUM
    type_id_name: string
    parent?: number
    limit?: number
}

export interface LocationOption {
    id: number
    name: string
    code: string
    type_id_name: string
    is_major: boolean
    index: number | null
}

export type LocationOptionsResponse = PartipostApiPaginationWrapper<LocationOption[]>

export const getLocationOptions = (payload: LocationOptionsRequest) =>
    api.get<PartipostApiResponse<LocationOptionsResponse>>('cities/', payload)

export interface ProfileOptionsRequest {
    country?: COUNTRY_ENUM
}

export enum PLATFORM_ENUM {
    IG = 1,
    FB = 2,
    TIKTOK = 3,
    TWITTER = 4,
    YOUTUBE = 5,
    THREADS = 6,
    XIAOHONGSHU = 7,
    OTHER = 99,
}

export enum PLATFORM_LABEL {
    FACEBOOK = 'Facebook',
    INSTAGRAM = 'Instagram',
    INSTAGRAMREEL = 'InstagramReel',
    TIKTOK = 'Tiktok',
    TWITTER = 'Twitter',
    YOUTUBE = 'Youtube',
    XIAOHONGSHU = 'Xiaohongshu',
}

export interface OccupationOption {
    id: number
    label: string
}

export interface FollowerTierOption {
    id: number
    platform: PLATFORM_ENUM
    min: number
    max: number
}
export interface FollowerTierFilterOption {
    label: string
    value: number
}
export interface ProfileTypeOption {
    id: number
    label: string
    profile_key: string
}

export interface ProfileOptionsResponse {
    occupations: OccupationOption[]
    social_media_follower_number_tiers: FollowerTierOption[]
    profile_types: ProfileTypeOption[]
}

export const getProfileOptions = (payload: ProfileOptionsRequest) =>
    api.get<PartipostApiResponse<ProfileOptionsResponse>>('profile/options-data/', payload)

export interface AddTagPayload {
    name: string
    categoryUuid: string
    categoryEnum: TagCategoryEnum
    onSuccessCallback?: (tag?: Tag) => void
    onErrorCallback?: (tag?: Tag) => void
}

export const addTag = (payload: AddTagPayload) => {
    const body = {
        name: payload.name,
        category: {
            uuid: payload.categoryUuid,
        },
    }
    return api.post<PartipostApiResponse<Tag>>(`tags/`, body)
}

export interface GetTagsPayload {
    categoryId?: string
    onSuccessCallback?: (tags?: Tag[]) => void
}

export const getTags = (payload: GetTagsPayload) => {
    const { categoryId } = payload

    return api.get<PartipostApiResponse<Tag[]>>(`tags/${categoryId ? '?category=' + categoryId : ''}`)
}

export interface OnboardingOptionsResponse {
    product_types: Record<string, string[]>
    platform_types: string[]
    challenges: string[]
}

export const getOnboardingOptions = () =>
    api.get<PartipostApiResponse<OnboardingOptionsResponse>>('common/data/onboarding-options/')
